<div class="verify-email-container">
  <div class="verify-email-card">
    <div class="verify-email-header">
      <h1>Email Verification</h1>
      @if (verifying) {
        <p>Please wait while we verify your email...</p>
      }
    </div>

    @if (verifying) {
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>Verifying your email...</p>
      </div>
    }

    @if (success) {
      <div class="alert-message success-message">
        {{ successMessage }}
        <div class="redirect-message">Redirecting to login...</div>
      </div>
    }

    @if (!verifying && !success) {
      <div class="alert-message error-message">
        {{ errorMessage }}
        <div class="action-links">
          <a routerLink="/login">Go to Login</a>
          <span class="separator">|</span>
          <a routerLink="/signup">Sign Up Again</a>
        </div>
      </div>
    }
  </div>
</div>
